import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getCronTriggerPath } from '~entities/stripe/lib/cron-api-path';
import { baseAPI } from '~shared/api/base-api';

interface TriggerUpcomingPaymentsParams {
  isV2: boolean;
}

export const triggerUpcomingPayments = async (
  params: TriggerUpcomingPaymentsParams,
) => {
  const response = await baseAPI.post<{ ok?: true }>(
    getCronTriggerPath('upcoming-payments', params.isV2),
  );
  return response.data;
};

export const useTriggerUpcomingPayments = () => {
  return useMutation({
    mutationFn: triggerUpcomingPayments,
    onSuccess: () => {
      toast.success('Upcoming payments cron triggered successfully');
    },
    onError: (error: unknown) => {
      const errorMessage =
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'data' in error.response &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'Failed to trigger upcoming payments cron.';

      toast.error(errorMessage);
    },
  });
};
